import { error } from 'protractor';
import { Observable, throwError, concat, of } from 'rxjs';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpUserEvent, HttpErrorResponse, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';
import * as globalAdd from '../connectionString';
import { WebUserService } from './services/WebUser.service';
import { WebUserDetails } from '../shared/models/WebUserDetails';
import { tap, retry, catchError } from 'rxjs/operators';
import { AlertMessages, AlertType } from './AlertMessages';
import { AppComponent } from '../app.component'; 


@Injectable()
export class TokenExpireInterceptor implements HttpInterceptor {

  refreshTokenInProgress: boolean = false;
  currentUser: WebUserDetails;
  allUsers: WebUserDetails[];
  constructor(private router: Router, private webSer: WebUserService,
    private appComponent: AppComponent) {
    this.allUsers = JSON.parse(localStorage.getItem('userDetails'));
    if (this.allUsers != undefined && this.allUsers != null) {
      this.currentUser = this.allUsers.filter(i => i.id == JSON.parse(sessionStorage.getItem('Id')))[0];
    }
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.allUsers = JSON.parse(localStorage.getItem('userDetails'));
    if (req.headers.get('No-Auth') == 'True') {
      return next.handle(req.clone());
    }
    else if(req.headers.get('paypal') == 'true')
    {
      let newRequest: HttpRequest<any> = req.clone();
      newRequest.headers.delete('paypal');
      return next.handle(newRequest);
    }

    if (this.allUsers != undefined && this.allUsers != null) {
      this.currentUser = this.allUsers.filter(i => i.id == JSON.parse(sessionStorage.getItem('Id')))[0];
      if (this.currentUser == undefined || this.currentUser == null) {
        this.router.navigateByUrl('/login');
      }
    }
    if (this.currentUser.userToken != null) {
      const clonedreq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + this.currentUser.userToken)
      });

      return next.handle(clonedreq).pipe(tap(
        succ => {
          // console.log(succ);
        },
        err => {

          if (err.status === 401) {
            AlertMessages.Show('HTTP ERROR: ' + err.status, err.statusText, AlertType.Error);
            var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
            var data = 'refresh_token=' + this.currentUser.refreshToken + '&grant_type=refresh_token';
            req = new HttpRequest('POST', globalAdd.Paneladdress + 'token', data, { headers: reqHeader });

            return next.handle(req).subscribe((data3: HttpResponse<any>) => {
              var AllData = Object.assign(Array(), data3.body);
              this.currentUser.userToken = AllData.access_token;
              this.currentUser.userRole = AllData.role;
              this.currentUser.refreshToken = AllData.refresh_token;
              this.allUsers[this.allUsers.findIndex(i => i.id == JSON.parse(sessionStorage.getItem('Id')))] = this.currentUser;
              localStorage.setItem('userDetails', JSON.stringify(this.allUsers));
            });
          } else if (err.status === 400 || err.status === 404 || err.status === 500 || err.status === 0) {
            return throwError(err);
          } else {
            let index = this.allUsers.findIndex(user => user.id == this.webSer.getUserId());
            this.allUsers.splice(index, 1);
            localStorage.setItem('userDetails', JSON.stringify(this.allUsers));
            this.webSer.updateUser('');
            localStorage.clear();
            alert('Redirecting to login,Please refresh the LOGIN page manually before use!');
            this.router.navigateByUrl('/login');
          }
        }
      ),
        retry(2),
        catchError(resp => {
          if (resp instanceof HttpErrorResponse) {
            for (let i = 0; i < resp.error.length; i++) {
              AlertMessages.Show('Server Exception!', resp.error[i], AlertType.Error);
            }
          }
          return throwError(resp);
        })
      );
    } else {
      localStorage.clear();
      alert('Redirecting to login,Please refresh the LOGIN page manually before use!');
      this.router.navigateByUrl('/login');
    }
  }
}
